import { Route, Routes } from "react-router-dom";
import PublicRouteV2 from "components/v2/login/PublicRouteV2";
import PrivateRouteV2 from "components/v2/login/PrivateRouteV2";
import Header from "components/header/Header";
import LoginPage from "pages/login/LoginPage";
import ShopV2 from "components/v2/shop/ShopV2";
import ShopApplicationV2 from "components/v2/shop/ShopApplicationV2";
import ShopApplicationNewV2 from "components/v2/shop/ShopApplicationNewV2";
import ShopApplicationDetailV2 from "components/v2/shop/ShopApplicationDetailV2";
import ShopInfo1V2 from "components/v2/shop/ShopInfo1V2";
import ShopInfo2V2 from "components/v2/shop/ShopInfo2V2";
import ShopInfo3V2 from "components/v2/shop/ShopInfo3V2";
import ShopInfo5V2 from "components/v2/shop/ShopInfo5V2";
import UserV2 from "components/v2/manage/UserV2";

import "./static/css/common.css";
import "assets/css/command.css";
import "assets/css/common.css";
import "assets/css/style.css";
import "static/css/v2Common.css";
import "static/css/shop.css";
import "static/css/menu.css";
import "styles/common.scss";
import "styles/command.scss";

import SubNavigate from "components/header/SubNavigate";
import StatisticsV2 from "./components/v2/order/StatisticsV2";
import Statistics2V2 from "./components/v2/order/Statistics2V2";
import FindLoginId from "./pages/login/FindLoginId";
import ResetPassword from "./pages/login/ResetPassword";
import ShopInfo4V22 from "./components/v2/shop/ShopInfo4V22";
import LoadingPopup from "./components/popup/LoadingPopup";
import MenuListPage from "./pages/menu/MenuListPage";
import OptionListPage from "./pages/menu/OptionListPage";
import ReviewPage from "./pages/review/ReviewPage";
import OriginPage from "./pages/menu/OriginPage";
import CouponPage from "./pages/coupon/CouponPage";
import { ApplicationPage } from "./pages/login/ApplicationPage";
import OrderPage from "./pages/order/OrderPage";
import UserPage from "./pages/user/UserPage";
import YearlyPage from "./pages/statistics/YearlyPage";
import ShopPage1 from "./pages/shop/ShopPage1";
import { DongApplicationV2 } from "./components/v2/shop/DongApplicationV2";
import MenuListV2 from "./components/v2/menu/MenuListV2";
import OptionListV2 from "./components/v2/menu/OptionListV2";
import MenuOriginV2 from "./components/v2/menu/MenuOriginV2";
import CouponListV2 from "./components/v2/manage/CouponListV2";
import ReviewListV2 from "./components/v2/manage/ReviewListV2";
import OrderListV2 from "./components/v2/order/OrderListV2";
import Login from "./pages/login/Login";
import PublicRoute from "./components/login/PublicRoute";
import PrivateRoute from "./components/login/PrivateRoute";
import MonthlyPage from "./pages/statistics/MonthlyPage";
import { useEffect } from "react";
import ResetPasswordV2 from "./pages/login/ResetPasswordV2";
import ShopPage2 from "./pages/shop/ShopPage2";
import ShopPage3 from "./pages/shop/ShopPage3";
import ShopPage4 from "./pages/shop/ShopPage4";
import ShopPage5 from "./pages/shop/ShopPage5";
import FindLoginIdV2 from "./pages/login/FindLoginIdV2";
import ImageEditor from "./components/imageEdit/ImageEditor";
import Test from "./components/v2/menu/Test";
import MenuListV2Test from "./components/v2/menu/MenuListV2Test";
import {WEB_VERSION} from "./constants/apiUrls"


function App() {
  let header = <></>;
  let subnav = <></>;
  const pathName = window.location.pathname;

  if (
    pathName !== "/" &&
    pathName !== "/v2" &&
    pathName !== "/v2/application" &&
    pathName !== "/v2/application2" &&
    pathName !== "/v2/findId" &&
    pathName !== "/v2/resetPassword" &&
    pathName !== "/test" &&
    pathName !== "/test/" &&
    pathName !== "/test/v2/application" &&
    pathName !== "/test/v2/application2" &&
    pathName !== "/test/v2/test/" &&
    pathName !== "/test/v2/findId" &&
    pathName !== "/test/v2/resetPassword"
  ) {
    header = <Header />;
    subnav = <SubNavigate />;
  }

  useEffect(() => {
    if (window.localStorage.getItem("version") !== WEB_VERSION) {
      window.localStorage.setItem("version", WEB_VERSION);
      window.location.reload();
    }
  }, []);

  return (
    <div className="App">
      <LoadingPopup />
      {header}
      <div className="d-flex j-left">
        {subnav}
        <Routes>
          {/*<Route path='/' element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path='/v2' element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path='/v2/application' element={<ApplicationPage />} />
          <Route path='/v2/shopInfo1' element={<PrivateRoute><ShopPage1 /></PrivateRoute>} />
          <Route path='/v2/shopInfo2' element={<PrivateRoute><ShopPage2 /></PrivateRoute>} />
          <Route path='/v2/shopInfo3' element={<PrivateRoute><ShopPage3 /></PrivateRoute>} />
          <Route path='/v2/shopInfo4' element={<PrivateRoute><ShopPage4 /></PrivateRoute>} />
          <Route path='/v2/shopInfo5' element={<PrivateRoute><ShopPage5 /></PrivateRoute>} />

          <Route path='/v2/menuList' element={<PrivateRoute><MenuListPage /></PrivateRoute>} />
          <Route path='/v2/optionList' element={<PrivateRoute><OptionListPage /></PrivateRoute>} />
          <Route path='/v2/menuOrigin' element={<PrivateRoute><OriginPage /></PrivateRoute>} />
          <Route path='/v2/review' element={<PrivateRoute><ReviewPage /></PrivateRoute>} />
          <Route path='/v2/coupon' element={<PrivateRoute><CouponPage /></PrivateRoute>} />
          <Route path='/v2/user' element={<PrivateRoute><UserPage /></PrivateRoute>} />
          <Route path='/v2/orderList' element={<PrivateRoute><OrderPage /></PrivateRoute>} />
          <Route path='/v2/statistics' element={<PrivateRoute><YearlyPage /></PrivateRoute>} />
          <Route path='/v2/statistics/month' element={<PrivateRoute><MonthlyPage /></PrivateRoute>} />
          <Route path="/v2/findId" element={<FindLoginIdV2 />} />
          <Route path="/v2/resetPassword" element={<ResetPasswordV2 />} />*/}

          <Route
            path="/"
            element={
              <PublicRouteV2>
                <Login />
              </PublicRouteV2>
            }
          />
          <Route
            path="/v2"
            element={
              <PublicRouteV2>
                <Login />
              </PublicRouteV2>
            }
          />
          <Route path="/v2/application" element={<DongApplicationV2 />} />
          <Route
            path="/v2/shop"
            element={
              <PrivateRouteV2>
                <ShopV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopAppList"
            element={
              <PrivateRouteV2>
                <ShopApplicationV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/newShop"
            element={
              <PrivateRouteV2>
                <ShopApplicationNewV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopDetail/:shopId"
            element={
              <PrivateRouteV2>
                <ShopApplicationDetailV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopInfo1"
            element={
              <PrivateRouteV2>
                <ShopInfo1V2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopInfo2"
            element={
              <PrivateRouteV2>
                <ShopInfo2V2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopInfo3"
            element={
              <PrivateRouteV2>
                <ShopInfo3V2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopInfo4"
            element={
              <PrivateRouteV2>
                <ShopInfo4V22 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/shopInfo5"
            element={
              <PrivateRouteV2>
                <ShopInfo5V2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/optionList"
            element={
              <PrivateRouteV2>
                <OptionListV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/menuOrigin"
            element={
              <PrivateRouteV2>
                <MenuOriginV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/menuList"
            element={
              <PrivateRouteV2>
                <MenuListV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/review"
            element={
              <PrivateRouteV2>
                <ReviewListV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/coupon"
            element={
              <PrivateRouteV2>
                <CouponListV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/user"
            element={
              <PrivateRouteV2>
                <UserV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/orderList"
            element={
              <PrivateRouteV2>
                <OrderListV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/statistics"
            element={
              <PrivateRouteV2>
                <StatisticsV2 />
              </PrivateRouteV2>
            }
          />
          <Route
            path="/v2/statistics/month"
            element={
              <PrivateRouteV2>
                <Statistics2V2 />
              </PrivateRouteV2>
            }
          />
          <Route path="/v2/findId" element={<FindLoginId />} />
          <Route path="/v2/resetPassword" element={<ResetPassword />} />
          <Route
            path="/v2/test"
            element={
              <PrivateRouteV2>
                <MenuListV2Test />
              </PrivateRouteV2>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
